'use client'

import { Button } from '@/components/ui/button'
import { StickyBanner } from '@/components/ui/sticky-banner'
import { usePricingModal } from '@/hooks/usePricingModal'
import {
  hasEnoughEditCredits,
  hasEnoughExecuteCredits,
  hasNegativeAppCount,
} from '@/lib/subscription-utils'

import { useGetUserQuotaQuery } from '@/lib/features/user/userApi'

type UpgradeBannerProps = {
  checkExecuteCredits?: boolean
  checkAppCount?: boolean
  checkEditCredits?: boolean
}

export const UpgradeBanner = ({
  checkExecuteCredits = true,
  checkAppCount = true,
  checkEditCredits = true,
}: UpgradeBannerProps) => {
  const { data: quota, isLoading: quotaLoading, error: quotaError } = useGetUserQuotaQuery()
  const { setOpen: openPricingModal } = usePricingModal()

  if (quotaLoading || quotaError || !quota) return null

  if (!checkExecuteCredits || hasEnoughExecuteCredits(quota)) return null
  if (!checkAppCount || hasNegativeAppCount(quota)) return null
  if (!checkEditCredits || hasEnoughEditCredits(quota)) return null

  const handleUpgradeClick = () => {
    openPricingModal()
  }

  return (
    <StickyBanner className="absolute left-0 right-0 top-0 bg-[#f6c2c4]">
      <div className="flex w-full items-center justify-between">
        <p className="flex-1 text-center">
          You&apos;ve hit your account limit. Please upgrade your plan to continue
        </p>
        <Button
          className="mr-6 rounded-xl bg-black px-4 py-1 text-white shadow-sm hover:bg-black/80"
          onClick={handleUpgradeClick}
        >
          Upgrade
        </Button>
      </div>
    </StickyBanner>
  )
}

export default UpgradeBanner
